<script> 
  export default {
    name: 'FormError'
  }
</script>

<template>
  <div class="FormError text-danger font-weight-bold">
    <slot></slot>
  </div>
</template>
